<template>
  <div class="element-date">
    <DatePicker @on-change="change" :transfer="true" :type="query.type" :placeholder="query.placeholder||'请选择'" v-model="currentValue" :format="query.format" v-if="!query.readonly"></DatePicker>
    <label v-else>{{ currentValue }}</label>
  </div>
</template>

<script>
export default {
  name: 'elementDate',
  props: {
    value: {
      type: [String, Number, Date, Array],
      default: ''
    },
    query: {}
  },
  data () {
    return {
      currentValue: ''
    }
  },
  created () {
    this.currentValue = this.value
  },
  watch: {
    value: function (val) {
      this.currentValue = val
    }
  },
  methods: {
    change (val) {
      this.currentValue = val;
      this.$emit('input', this.currentValue);
    }
  }
}
</script>

<style lang="less" scoped>
  .element-date {
    .kh-date-picker {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/elements/date.vue